import { render, staticRenderFns } from "./EditTextTexto.vue?vue&type=template&id=7fd62efe&scoped=true&"
import script from "./EditTextTexto.vue?vue&type=script&lang=js&"
export * from "./EditTextTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd62efe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
